import Dashboard from '../containers/dashboard'
import AccountManagement from '../containers/account-management'

const Account = () => {
  return (
    <Dashboard>
      <AccountManagement />
    </Dashboard>
  )
}

export default Account
